import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ taskId, page = 1, perPage = 10 }) => {
  return await dponetAPI.get(`/kanban_tasks/${taskId}/task_comments`, {
    params: { page, perPage },
  })
}

const create = async ({ taskId, ...data }) => {
  return await dponetAPI.post(`/kanban_tasks/${taskId}/task_comments`, {
    taskComment: data,
  })
}

const update = async ({ taskId, commentId, ...data }) => {
  return await dponetAPI.put(
    `/kanban_tasks/${taskId}/task_comments/${commentId}`,
    { taskComment: data },
  )
}

const destroy = async ({ taskId, commentId }) => {
  return await dponetAPI.delete(
    `/kanban_tasks/${taskId}/task_comments/${commentId}`,
  )
}

export default { get, create, destroy, update }
